import { api } from '../../../lib/api';

/*
 * Lecturas de respuestas que comparten las vistas de la pestaña Respuestas.
 */

const POR_PAGINA = 200;
const TOPE = 5000;

/** Todas las respuestas en orden de llegada (por páginas de 200; tope de 5000 para no colgar el navegador). */
export async function cargarTodas(formId) {
  const items = [];
  let total = Infinity;
  while (items.length < Math.min(total, TOPE)) {
    // eslint-disable-next-line no-await-in-loop
    const { data } = await api.get(`/forms/${formId}/respuestas`, {
      params: { desde: items.length, limite: POR_PAGINA, orden: 'asc' },
    });
    total = data.total ?? 0;
    const pagina = data.items || [];
    items.push(...pagina);
    if (pagina.length < POR_PAGINA) break;
  }
  return { items, total: Number.isFinite(total) ? total : items.length, recortado: items.length < total };
}

/** Nombre de archivo de una cabecera Content-Disposition (con o sin filename*=UTF-8''…). */
export function nombreDeDisposicion(cabecera) {
  if (!cabecera) return null;
  const utf = /filename\*\s*=\s*UTF-8''([^;]+)/i.exec(cabecera);
  if (utf) {
    try {
      return decodeURIComponent(utf[1].replace(/"/g, ''));
    } catch {
      /* cae al nombre simple */
    }
  }
  const simple = /filename\s*=\s*"?([^";]+)"?/i.exec(cabecera);
  return simple ? simple[1] : null;
}

/** Descarga un blob con su nombre (sin abrir pestañas). */
export function guardarBlob(blob, nombre) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = nombre;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1500);
}
